<div class="voyage-list-filters">
  <div class="voyage-list-filters-tabs">
    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.ALL)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.ALL }">
        {{ "LABELS.ALL" | translate }}
      </span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.ACTIVE)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.ACTIVE }">
        {{ "LABELS.ACTIVE" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.active }})</span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.PUBLISHED)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.PUBLISHED }">
        {{ "VOYAGE_STATUS.PUBLISHED" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.published }})</span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.IN_TRANSIT)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.IN_TRANSIT }">
        {{ "VOYAGE_STATUS.IN_TRANSIT" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.inTransit }})</span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.AT_ARRIVAL_PORT)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.AT_ARRIVAL_PORT }">
        {{ "VOYAGE_STATUS.AT_ARRIVAL_PORT" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.atArrivalPort }})</span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.AT_DESTINATION_WAREHOUSE)">
      <span
        class="voyage-list-filters-tabs-item-link"
        [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.AT_DESTINATION_WAREHOUSE }"
      >
        {{ "VOYAGE_STATUS.AT_DESTINATION_WAREHOUSE" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.atDestinationWarehouse }})</span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.DRAFTS)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.DRAFTS }">
        {{ "VOYAGE_STATUS.DRAFT" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.drafts }})</span>
    </div>

    <div class="voyage-list-filters-tabs-item" (click)="selectTab.emit(enumVoyageStatusTab.EXPIRED)">
      <span class="voyage-list-filters-tabs-item-link" [ngClass]="{ active: currentSelectedTab === enumVoyageStatusTab.EXPIRED }">
        {{ "VOYAGE_STATUS.EXPIRED" | translate }}
      </span>
      <span class="voyage-list-filters-tabs-item-count">({{ tabsCount.expired }})</span>
    </div>
  </div>
</div>

<div *ngIf="total === 0" class="disabled">
  <span>{{ "LABELS.EMPTY_LIST" | translate }}</span>
</div>

<div
  class="voyage-item"
  *ngFor="let voyage of voyages$ | async | paginate : { id: tableId, itemsPerPage: limit, currentPage: page, totalItems: total }"
  (click)="openVoyage(voyage.id)"
>
  <view-voyage [voyage]="voyage" [quotesCount]="0" [isListItem]="true"></view-voyage>
</div>

<loading-spinner [show]="isLoading"></loading-spinner>

<div class="d-flex justify-content-between align-items-center flex-wrap">
  <div class="py-2">
    <ng-template [ngIf]="totalRows">{{ "LABELS.TOTAL_ROWS" | translate }}: {{ totalRows }}/{{ total }}</ng-template>
  </div>
  <div class="py-2 mx-2 d-flex">
    <ng-select
      id="page-limit"
      class="custom"
      [items]="[20, 50, 100]"
      [clearable]="false"
      [ngModel]="limit"
      (ngModelChange)="limitChanged.emit($event)"
    ></ng-select>
    <ng-template [ngIf]="total > limit">
      <pagination-controls
        class="custom-pagination"
        [id]="tableId"
        [maxSize]="7"
        [previousLabel]="'LABELS.PREVIOUS' | translate"
        [nextLabel]="'LABELS.NEXT' | translate"
        (pageChange)="pageChanged.emit($event)"
        (pageBoundsCorrection)="pageChanged.emit($event)"
      ></pagination-controls>
    </ng-template>
  </div>
</div>
